/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Email } from '../model';
// @ts-ignore
import { EmailConfirmation } from '../model';
// @ts-ignore
import { GetEmailVerificationList200Response } from '../model';
// @ts-ignore
import { IdentityResponse } from '../model';
/**
 * VerificationApi - axios parameter creator
 * @export
 */
export const VerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns a list of email verifications
         * @summary Individual - Get list email verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerificationList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/individual/email/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Send email verification
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpMail: async (email: Email, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendOtpMail', 'email', email)
            const localVarPath = `/v2/private/individual/email/send-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = email

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This confirms an email address.
         * @summary Individual - Verify email
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (emailConfirmation: EmailConfirmation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailConfirmation' is not null or undefined
            assertParamExists('verifyEmail', 'emailConfirmation', emailConfirmation)
            const localVarPath = `/v2/private/individual/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = emailConfirmation

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerificationApi - functional programming interface
 * @export
 */
export const VerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns a list of email verifications
         * @summary Individual - Get list email verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailVerificationList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailVerificationList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailVerificationList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Send email verification
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtpMail(email: Email, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtpMail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This confirms an email address.
         * @summary Individual - Verify email
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(emailConfirmation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VerificationApi - factory interface
 * @export
 */
export const VerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerificationApiFp(configuration)
    return {
        /**
         * This returns a list of email verifications
         * @summary Individual - Get list email verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerificationList(options?: any): AxiosPromise<GetEmailVerificationList200Response> {
            return localVarFp.getEmailVerificationList(options).then((request) => request(axios, basePath));
        },
        /**
         * This resends an email that has a confirmation code.
         * @summary Individual - Send email verification
         * @param {Email} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpMail(email: Email, options?: any): AxiosPromise<void> {
            return localVarFp.sendOtpMail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This confirms an email address.
         * @summary Individual - Verify email
         * @param {EmailConfirmation} emailConfirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(emailConfirmation: EmailConfirmation, options?: any): AxiosPromise<IdentityResponse> {
            return localVarFp.verifyEmail(emailConfirmation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerificationApi - interface
 * @export
 * @interface VerificationApi
 */
export interface VerificationApiInterface {
    /**
     * This returns a list of email verifications
     * @summary Individual - Get list email verifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    getEmailVerificationList(options?: AxiosRequestConfig): AxiosPromise<GetEmailVerificationList200Response>;

    /**
     * This resends an email that has a confirmation code.
     * @summary Individual - Send email verification
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    sendOtpMail(email: Email, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * This confirms an email address.
     * @summary Individual - Verify email
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig): AxiosPromise<IdentityResponse>;

}

/**
 * VerificationApi - object-oriented interface
 * @export
 * @class VerificationApi
 * @extends {BaseAPI}
 */
export class VerificationApi extends BaseAPI implements VerificationApiInterface {
    /**
     * This returns a list of email verifications
     * @summary Individual - Get list email verifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public getEmailVerificationList(options?: AxiosRequestConfig) {
        return VerificationApiFp(this.configuration).getEmailVerificationList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This resends an email that has a confirmation code.
     * @summary Individual - Send email verification
     * @param {Email} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public sendOtpMail(email: Email, options?: AxiosRequestConfig) {
        return VerificationApiFp(this.configuration).sendOtpMail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This confirms an email address.
     * @summary Individual - Verify email
     * @param {EmailConfirmation} emailConfirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public verifyEmail(emailConfirmation: EmailConfirmation, options?: AxiosRequestConfig) {
        return VerificationApiFp(this.configuration).verifyEmail(emailConfirmation, options).then((request) => request(this.axios, this.basePath));
    }
}
